import React, {Suspense} from "react";
import {useSelector} from "react-redux";
import Sticky from "wil-react-sticky";
import Loader from "../../components/loader/Loader";
import {
  ROLE_ROOT,
  ROLE_ADMIN,
  ROLE_MODERATOR,
  ROLE_JURY,
  ROLE_MANAGER,
  ROLE_PARTICIPANT
} from "../../data/Role";

const RootRouter = React.lazy(() => import('../roles/root/action/RootRouter'));
const AdminRouter = React.lazy(() => import('../roles/admin/action/AdminRouter'));
const ModeratorRouter = React.lazy(() => import('../roles/moderator/action/ModeratorRouter'));
const JuryRouter = React.lazy(() => import('../roles/jury/action/JuryRouter'));
const ManagerRouter = React.lazy(() => import('../roles/manager/action/ManagerRouter'));
const ParticipantRouter = React.lazy(() => import('../roles/participant/action/ParticipantRouter'));
const GuestRouter = React.lazy(() => import('../roles/guest/action/GuestRouter'));

export default function Actions() {
  const user = useSelector(state => state.user);

  return (
    <div className={user.isGuest ? 'actions-guest' : 'actions-auth'}>
      <Sticky containerSelectorFocus={'actions-side'}>
        <Suspense fallback={<Loader/>}>
          {renderRouter()}
        </Suspense>
      </Sticky>
    </div>
  );

  function renderRouter() {
    if (null === user.profile) {
      return <GuestRouter/>;
    }

    const roleName = user.profile.role.name;

    if (ROLE_ROOT === roleName) {
      return <RootRouter/>;
    } else if (ROLE_ADMIN === roleName) {
      return <AdminRouter/>;
    } else if (ROLE_MODERATOR === roleName) {
      return <ModeratorRouter/>;
    } else if (ROLE_JURY === roleName) {
      return <JuryRouter/>;
    } else if (ROLE_MANAGER === roleName) {
      return <ManagerRouter/>;
    } else if (ROLE_PARTICIPANT === roleName) {
      return <ParticipantRouter/>;
    }

    return <GuestRouter/>;
  }
}
